module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAALCAYAAABlNU3NAAAA7ElEQVQ4T63SPSvFURwH8M9XlAyMssisjPIKDKKwyGA2GZXXoIwms0EZUKS8AmVUZllkZGAQf10d4l7u/3o406nz+30/5ylQVdUEuhvzfxxPSU5TgCnsoP+fgDssJjl+BQoyhkMM/xG5wkyS80bOO1CQIRxg/JfIGWaTXL/1fwIK0odtzP8Q2cNSkvuPfS1AQbqwjtUOkQ2sJXlurv8S+PAuy9hEzzfQI1aSbH23kbZAOc0kdjHQFHKLhSQn7U5ZCxRkFEcYKWGXmE5yUXeFHQEFGcR+CZxLclMX3vJN6xqqquptfO0kD3W1b+sva+s+DHQuAMIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/downarrow.png
// module id = Rrtx
// module chunks = 3